/* eslint-disable vue/no-v-html */
<template>
  <div class="main">
    <header class="header">
      <mt-swipe
        v-if="detail.imageUrls&&detail.imageUrls.length>0"
        :auto="2000"
      >
        <mt-swipe-item
          v-for="(url, index) in detail.imageUrls"
          :key="index"
        >
          <img
            class="header-img"
            :src="url"
            alt="图片"
          >
        </mt-swipe-item>
      </mt-swipe>
    </header>
    <section class="base-info">
      <main class="base-info-main">
        <h3 class="name">
          <span>{{ detail.itemName }}</span>
          <span class="cost">{{ detail.cost }}奖励金</span>
        </h3>
        <h5 style="overflow: hidden;">
          <span
            v-show="detail.soldNum"
            class="count"
          >已兑{{ detail.soldNum }}件</span>
          <!-- <span class="price">¥{{ detail.price }}</span> -->
        </h5>
      </main>
      <!-- <h5 class="base-info-date">
        2020-10-29前可兑
      </h5> -->
    </section>

    <article class="description">
      <h1 class="description-title">
        商品说明
      </h1>
      <!-- eslint-disable vue/no-v-html -->
      <section
        class="description-content"
        v-html="detail.itemDetail"
      />
    </article>
    <div class="block" />
    <footer class="footer">
      <p
        class="balance"
      >
        {{ points }}奖励金可用
      </p>
      <div
        v-if="isShowGroupBtns"
        class="group-btns"
      >
        <button
          class="btn-pay"
          @click="onPay"
        >
          使用{{ detail.pointsDeduction }}币+{{ detail.salePriceAfterDeduction }}元
        </button>
        <button
          class="btn-exchange small-btn"
          @click="onExchange"
        >
          马上兑换
        </button>
      </div>
      <button
        v-else
        class="btn-exchange"
        @click="onExchange"
      >
        马上兑换
      </button>
    </footer>
    <exchange
      ref="exchange"
      :amount="amount"
      :points="points"
      from="detail"
      @success="fetchData"
    />
  </div>
</template>

<script>
import { Native } from '@hb/NBridge/lib/h5';
import Toast from '@/components/toast';
import { Swipe, SwipeItem } from 'mint-ui';
import { ParamsUtil } from '@/utils/params';
import { createCouponOrder } from '@/pages/welfare/common/helper';
import pay from '@/pages/welfare/common/pay';
import { isPreRender } from '../../utils/index';
import { getAwardDetail, getBountyBasicInfo, declineCouponOrder } from '../../api/bounty';
import Exchange from './components/exchange-list/exchange';
import SPM from '../welfare/common/spm';

export default {
  components: {
    mtSwipe: Swipe,
    mtSwipeItem: SwipeItem,
    Exchange,
  },
  data() {
    return {
      skuId: '',
      detail: {
        imageUrls: [],
      },
      amount: 0,
      points: 0,
      isHideBonus: ParamsUtil.getParam('hideBonus') === 'true',
    };
  },
  computed: {
    isShowGroupBtns() {
      const {
        pointsDeduction, salePriceAfterDeduction, itemName, skuId,
      } = this.detail;
      const isShow = !this.isHideBonus && pointsDeduction && salePriceAfterDeduction;
      if (isShow) {
        SPM.moduleExpose({
          pageId: 'Bonus_Commodity.details',
          moduleId: 'platform_detailsAddCashBuy',
          contentId: 'platform_detailsAddCashBuy',
          businessInfo: {
            goodsName: itemName,
            skuId,
            adsource: ParamsUtil.getParam('adsource'),
            exchangeNeedCash: salePriceAfterDeduction,
            exchangebonus: pointsDeduction,
          },
        });
      }
      return isShow;
    },
  },
  created() {
    this.skuId = this.$route.params.id;
    if (isPreRender()) {
      return;
    }
    this.fetchData();
  },
  mounted() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
    }
  },
  methods: {
    async onPay() {
      const {
        salePriceAfterDeduction, skuId, salePrice, promotionInfos, itemName, pointsDeduction,
      } = this.detail;
      SPM.clickButton({
        pageId: 'Bonus_Commodity.details',
        buttonName: 'platform_detailsAddCashBuy',
        businessInfo: {
          goodsName: itemName,
          skuId,
          adsource: ParamsUtil.getParam('adsource'),
          exchangeNeedCash: salePriceAfterDeduction,
          exchangebonus: pointsDeduction,
        },
      });
      let _orderId;
      try {
        const {
          businessScene,
          businessType,
          orderId,
          payMoney,
          payOrderId,
        } = await createCouponOrder({
          payAmount: salePriceAfterDeduction,
          itemList: [{
            skuId,
            num: 1,
            salePrice,
            promotionInfos,
          }],
        }, true);
        _orderId = orderId;
        const res = await pay({
          payOrderInfo: {
            businessScene,
            businessType,
            payMoney,
            payOrderId,
            orderId,
          },
        });
        if (res) {
          this.$refs.exchange.exchangeSuccessCallback(this.detail);
        }
      } catch (error) {
        if (error.code === '2002') {
          Toast.show('用户取消支付');
          const { token: cancelToken, userNewId } = await Native.getTokenAndKey();
          await declineCouponOrder({ orderId: _orderId, userNewId, token: cancelToken });
        } else {
          Toast.show(error.message || '支付失败');
        }
        // 刷新页面数据
        await this.fetchData();
      }
    },
    async fetchData() {
      const { token } = await Native.getTokenAndKey();
      this.token = token;
      try {
        const { cityCode, adCode } = await Native.getCityInfo();

        // this.ticket = ticket;
        await this.getAward(token, cityCode, adCode);
        await this.getBasic(token);
      } catch (e) {
        //
        await this.getAward(token);
        await this.getBasic(token);
      }
      SPM.pageView({
        pageId: 'Bonus_Commodity.details',
        categoryId: 'platform',
        businessInfo: {
          Trade_name: this.detail.itemName,
          skuId: this.skuId,
          pageFrom: ParamsUtil.getParam('adsource'),
        },
      });
    },
    async getAward(token, cityCode = '', adCode = '') {
      const res = await getAwardDetail({
        guid: this.skuId,
        skuId: this.skuId,
        token: token || this.token,
        cityCode,
        adCode,
        includeOption: {
          includePromo: true,
          includeUserLimit: false,
        },
      });
      if (res && res.code === 0) {
        if (res.useStatus === 0) {
          Toast.show('该商品已下架');
          this.$router.go(-1);
          return;
        }
        this.detail = res.data;
        if (this.detail.itemMedias) {
          this.detail.imageUrls = this.detail.itemMedias
            .filter((media) => media.mediaPlace !== 1)
            .map((media) => media.mediaUrl);
          const awardImage = this.detail.itemMedias.find((media) => media.mediaPlace === 1);
          if (awardImage) {
            this.detail.image = awardImage.mediaUrl;
          }
        }
        if (this.detail.sku) {
          const {
            originalPrice,
            saleNum,
            realNum,
            totalNum,
            virtualSalePrice,
            virtualType,
            salePriceAfterDeduction,
            pointsDeduction,
            salePrice,
          } = this.detail.sku;
          this.detail.soldNum = totalNum - realNum;
          this.detail.saleNum = saleNum;
          this.detail.salePrice = originalPrice;
          this.detail.price = originalPrice;
          this.detail.virtualSalePrice = virtualSalePrice;
          this.detail.cost = virtualSalePrice;
          this.detail.title = this.detail.itemName;
          this.detail.virtualType = virtualType;
          this.detail.salePriceAfterDeduction = salePriceAfterDeduction;
          this.detail.pointsDeduction = pointsDeduction;
          this.detail.salePrice = salePrice;
          if (this.detail.promotionInfos && this.detail.promotionInfos.length) {
            this.detail.promotionInfos = this.detail.promotionInfos.map((item) => ({
              ...item,
              worth: item.deductionAmount,
            }));
          }
        }
      }
    },
    getBasic(token) {
      getBountyBasicInfo({
        token: token || this.token,
        pointType: 1,
      }).then((v) => {
        if (v && v.data) {
          const { points, amount } = v.data;
          this.amount = amount;
          this.points = points;
        }
      }).catch(() => {});
    },
    onExchange() {
      SPM.clickButton({
        pageId: 'Bonus_Commodity.details',
        buttonName: 'Bonus_Commodity.details_exchange',
        businessInfo: {
          Trade_name: this.detail.itemName,
          skuId: this.skuId,
          pageFrom: ParamsUtil.getParam('adsource'),
        },
      });
      this.$refs.exchange.doExchange(this.detail);
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  background: rgba(248, 248, 248, 1);
  min-height: 100vh;
  padding-bottom: 1rem;
}

.base-info {
  font-size: 0.14rem;
  padding: 0 0.15rem;
  background: white;
}

.name {
  font-size: 0.18rem;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
}

.cost {
  font-size: 0.12rem;
  font-weight: 500;
  color: rgba(250, 100, 0, 1);
  float: right;
}

.count {
  font-size: 0.12rem;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}

.price {
  font-size: 0.12rem;
  font-weight: 400;
  color: rgba(204, 204, 204, 1);
  text-decoration: line-through;
  float: right;
}

.base-info-date {
  padding: 0.14rem 0;
  color: rgba(153, 153, 153, 1);
}

.base-info-main {
  padding: 0.15rem 0;
  // border-bottom: 0.01rem solid #eee;
}

.header {
  height: 2.25rem;
}

.header-img {
  width: 100%;
  height: 2.25rem;
}

.description {
  font-size: 0.14rem;
  background: white;
  margin-top: 0.11rem;
  padding: 0.15rem;
}

.description-title {
  font-size: 0.18rem;
  font-weight: 500;
  color: #333;
}

.description-content {
  padding-top: 0.05rem;
  color: #666;
  font-size: 0.12rem;
  line-height: 0.2rem;
}

.footer {
  background: white;
  font-size: 0.16rem;
  box-shadow: 0 -0.04rem 0.2rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 0.16rem 0.16rem 0 0;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  padding: 0.1rem 0.15rem 0.34rem;
  text-align: center;
}

.btn-exchange {
  width: 100%;
  height: 0.43rem;
  line-height: 0.43rem;
  color: white;
  background: linear-gradient(90deg, rgb(255, 47, 93), rgb(255, 49, 38));
  border-radius: 0.22rem;
  font-size: 0.14rem;
  margin-bottom: 0.12rem;
  font-weight: 500;

  &.small-btn {
    flex: 1;
  }
}

.balance:extend(.cost) {
  float: none;
  margin-bottom: 0.1rem;
}

.block {
  height: 0.1rem;
}

.group-btns {
  display: flex;
  gap: 0.09rem;
}

.btn-pay {
  flex: 1;
  height: 0.43rem;
  line-height: 0.43rem;
  background: linear-gradient(291.9deg, #ffda9c 29.79%, #ffefd3 89.13%);
  border: 1px solid #ffe4b6;
  border-radius: 0.22rem;
  font-family: PingFang SC, sans-serif;
  font-size: 0.14rem;
  font-weight: 500;
  color: #7f3a27;
}
</style>
